import { useAuth0 } from '@auth0/auth0-vue';
import { toRaw } from 'vue';

/** ログインしているユーザーが属するアカウントのIDを返す */
const getOrganizationId = () => {
  const user = useAuth0().user;
  const organizationId = user.value?.org_id;
  return organizationId;
};

/** ログインしているユーザーが属するアカウントの名前を返す */
const getOrganizationName = () => {
  const auth0User = toRaw(useAuth0().user);
  if (auth0User.value) {
    return auth0User.value.organization.display_name;
  } else {
    return '';
  }
};

/** ログインしているユーザーのユーザー名を返す */
const getUserName = () => {
  const auth0User = toRaw(useAuth0().user);
  if (auth0User.value) {
    return auth0User.value.organization.name;
  } else {
    return '';
  }
};

/**ログインしているユーザーのユーザーIDを返す */
const getUserId = () => {
  const auth0 = toRaw(useAuth0().user.value);
  return auth0?.sub;
};

export const getUserRole = (): Role[] => {
  return toRaw(useAuth0()?.user?.value?.['organization/roles']);
};

type Role = {
  id: string;
  name: string;
  description: string;
};

export default {
  getOrganizationId,
  getOrganizationName,
  getUserName,
  getUserId,
};
